import React, { useState } from 'react';
import { Card, CardContent, CardActions, Button, Typography, Grid, TextField } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { MonetizationOn, PhonelinkLockOutlined, Feedback, Assignment, Payment } from '@mui/icons-material';
import LineaNegocio from '../../../components/admin/LineaNegocio';

const TarjetaReporte = ({ titulo, descripcion, IconoComponente, onButtonClick, disabled }) => {
  return (
    <Card style={{ margin: '1rem', textAlign: 'center' }}>
      <CardContent>
        <IconoComponente style={{ fontSize: 60, marginBottom: '1rem' }} />
        <Typography variant="h5" gutterBottom>
          {titulo}
        </Typography>
        <Typography variant="body2">{descripcion}</Typography>
      </CardContent>
      <CardActions>
        <Button variant="contained" color="primary" onClick={() => onButtonClick('download', titulo)} disabled={disabled}>
          Descargar
        </Button>
        <Button variant="outlined" color="primary" onClick={() => onButtonClick('preview', titulo)} disabled={disabled}>
          Vista Previa
        </Button>
      </CardActions>
    </Card>
  );
};

const Reportes = ({onAction }) => {
    const [linea, setLinea] = useState(null);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    const handleLineaChange = (linea) => {
        setLinea(linea);
    };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'fechaInicio') {
      setFechaInicio(value);
    } else if (name === 'fechaFin') {
      setFechaFin(value);
    }
  };
  const handleButtonClick = (actionType, reportTitle) => {
    const formData = {
      linea: linea,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      reportTitle: reportTitle,
      actionType: actionType
    };
    onAction(formData);
  };
  const isFormComplete = () => {
    return linea && fechaInicio && fechaFin;
  };
  const reportesBase = [
    { titulo: 'Llamadas', descripcion: 'Reporte de todas las llamadas', enlaceDescarga: '/descargar/llamadas', IconoComponente: PhonelinkLockOutlined },
    { titulo: 'Agendas', descripcion: 'Reporte de todas las agendas', enlaceDescarga: '/descargar/agendas', IconoComponente: CalendarTodayIcon },
    { titulo: 'Ventas', descripcion: 'Reporte de Ventas', enlaceDescarga: '/descargar/ventas', IconoComponente: MonetizationOn },
    { titulo: 'Feedback', descripcion: 'Reporte de feedback de clientes', enlaceDescarga: '/descargar/feedback', IconoComponente: Feedback },
    { titulo: 'Tareas', descripcion: 'Reporte de tareas asignadas', enlaceDescarga: '/descargar/tareas', IconoComponente: Assignment },
    { titulo: 'Pagos', descripcion: 'Reporte de compromisos de pagos', enlaceDescarga: '/descargar/pagos', IconoComponente: Payment },
  ];
  const reportesAdicionales = linea && linea.id === 2 ? [
    { titulo: 'Listar Ventas Alfin', descripcion: 'Reporte de ventas Alfin', enlaceDescarga: '/descargar/ventas-alfin', IconoComponente: MonetizationOn },
    { titulo: 'Listar Clientes Alfin', descripcion: 'Reporte de clientes Alfin', enlaceDescarga: '/descargar/clientes-alfin', IconoComponente: Feedback },
  ] : [];
  // Combinar los reportes base con los adicionales si los hay
    const reportes = [...reportesAdicionales, ...reportesBase];
  return (
        <Grid container spacing={4} justifyContent="center">
        <Grid item container spacing={2}>
          <Grid item xs={12}>
            <LineaNegocio onLineaChange={handleLineaChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="fechaInicio"
              label="Fecha de inicio"
              type="date"
              variant="outlined"
              value={fechaInicio}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="fechaFin"
              label="Fecha fin"
              type="date"
              variant="outlined"
              value={fechaFin}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Generar Reporte
            </Button>
          </Grid>
        </Grid>
      {reportes.map((reporte) => (
        
        <Grid item xs={12} sm={6} md={4} key={reporte.titulo}>
          <TarjetaReporte {...reporte} onButtonClick={handleButtonClick} disabled={!isFormComplete()} />
        </Grid>
      ))}
    </Grid>
  
  );
};

export default Reportes;
